<template>
  <!-- 按问题找律师列表页 -->
  <div class="lslist">
    <div class="lsbanner">
      <img src="~assets/findlawchild/lsbanner.png" alt="" />
    </div>
    <lltselec @cliwt="getnr" />
    <lltlocallaw :list = 'laywerlist' @turnpage = 'turnpage'/>
    <div class="w10ff"><lltlastrela /></div>
    
  </div>
</template>

<script>
import lltselec from "./child/lltselec";
import lltlocallaw from "./child/lltlocallaw";
import lltlastrela from "./child/lltlastrela";
export default {
  components: {
    lltselec,
    lltlocallaw,
    lltlastrela,
	page:1
  },
  data(){
	  return{
		laywerlist:[]
	  }
  },
  mounted() {
  this.$http.fdlaw.lawyerlist({
	  areaid:this.$route.params.cityid,
	  page:1,
	  majorid:this.$route.params.cateid,
	  tradeid:this.$route.params.tradeid,
	  problemid:this.$route.params.problemid,
	  goodat:this.$route.params.goodat
  }).then(res => {
  	this.laywerlist = res.data
  })
  },
  methods:{
    getnr(e){
      console.log(e);
    },
	turnpage(e){
		this.page = e
	}
  }
};
</script>

<style lang="scss" scoped>
.lslist {
  background: #f8f8f8;
  .lsbanner {
    max-width: 1920px;
    width: 100%;
    overflow: hidden;
    margin: 0 auto ;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .w10ff{
    width: 100%;
    background-color: #fff;
  }
}
</style>